module.exports = __webpack_public_path__ + "static/media/blackburn.7cd85534.jpg";